export { default } from './MetaList';
export type { MetaListProps } from './MetaList';
